// extracted by mini-css-extract-plugin
export default {"sobre_container":"Company_sobre_container__M5Gfl","sobre_texto":"Company_sobre_texto__dFjCt","categorias":"Company_categorias__YM8ZX","img":"Company_img__vv+2w"};